import { API_URL } from "@/mainconfig";

// CH-W32 — customer in-app notification center. Reads NotificationLogs (Channel=IN_APP) via /notification/me*.
const AUTH = { requiresAuth: true };

export default {
    namespaced: true,
    state: {
        items: [],
        unreadCount: 0,
        loading: false,
        page: 1,
        perPage: 10,
        total: 0,
        totalPages: 1,
    },
    getters: {
        unreadCount: (s) => s.unreadCount,
        previewItems: (s) => s.items.slice(0, 5),
    },
    mutations: {
        setItems(s, { data, meta }) {
            s.items = data || [];
            if (meta) {
                s.page = meta.page;
                s.perPage = meta.perPage;
                s.total = meta.total;
                s.totalPages = meta.totalPages;
            }
        },
        setUnreadCount(s, n) {
            s.unreadCount = n;
        },
        setLoading(s, v) {
            s.loading = v;
        },
        markReadLocal(s, id) {
            const item = s.items.find((i) => i.id === id);
            if (item && !item.isRead) {
                item.isRead = true;
                s.unreadCount = Math.max(0, s.unreadCount - 1);
            }
        },
        markAllReadLocal(s) {
            s.items.forEach((i) => (i.isRead = true));
            s.unreadCount = 0;
        },
    },
    actions: {
        async fetchUnreadCount({ commit }) {
            try {
                const res = await API_URL.get(`/notification/me/unread-count`, AUTH);
                commit("setUnreadCount", res.data?.data?.count || 0);
            } catch (e) {
                // silent — badge is non-critical
            }
        },
        async fetchList({ commit }, { unread = false, page = 1, perPage = 10 } = {}) {
            commit("setLoading", true);
            try {
                const res = await API_URL.get(`/notification/me`, {
                    ...AUTH,
                    params: { unread: unread ? 1 : 0, page, perPage },
                });
                commit("setItems", { data: res.data?.data || [], meta: res.data?.meta });
                return res.data?.data || [];
            } catch (e) {
                commit("setItems", { data: [], meta: null });
                throw e;
            } finally {
                commit("setLoading", false);
            }
        },
        async fetchDetail(_ctx, id) {
            const res = await API_URL.get(`/notification/me/${id}`, AUTH);
            return res.data?.data || null;
        },
        async markRead({ commit }, id) {
            try {
                await API_URL.post(`/notification/me/${id}/read`, {}, AUTH);
                commit("markReadLocal", id);
            } catch (e) {
                // silent
            }
        },
        async markAllRead({ commit }) {
            await API_URL.post(`/notification/me/read-all`, {}, AUTH);
            commit("markAllReadLocal");
        },
    },
};
